import { FunctionComponent } from "react";

export const MeinAutoLogo: FunctionComponent = () => {
  return (
    <img
      src="/images/brand/meinauto_logo.svg"
      className={"w-32 md:w-[161px] h-10 md:h-[50px]"}
      alt="MeinAuto"
    />
  );
};
